import { useEffect, useState } from 'react'
import { message, Tag } from 'antd'
import { DebtReschedulingConditionStatus, DebtReschedulingEligibilityStatus, ITable } from 'src/utils/commonInterfaces'
import helper from 'src/utils/helper'
import { useParams } from 'react-router-dom'
import { errorMessage } from 'src/utils/commonStringsConsts'
import tableHeaderConverter from 'src/utils/tableHeaderConverter'
import { TableWrapper } from 'src/utils/CallCenterTableWrapper'
import CallCenterTable from './callCenterTable'

function CallCenterDebtReschedulingTable() {
    const { userId }: { userId: string } = useParams<{ userId: string }>()
    const [debtReschedulingTable, setDebtReschedulingTable] = useState<ITable>({ data: [], columns: [], loading: true })
    const { eligible } = DebtReschedulingEligibilityStatus
    const { met } = DebtReschedulingConditionStatus
    
    useEffect(() => {
        fetchDebtReschedulingTable()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId])

    const fetchDebtReschedulingTable = async () => {
        try {
            const res: any = await helper.getCallCenterUserReschedulingEligibility(Number(userId))
            if(res.status !== 200) {
                message.error(`${errorMessage} with Rescheduling Eligibility`)
                return
            }
            const data = res?.data?.data
            const formattedData = data?.map((item: any, index: number) => {
                const userIdKey = Object.keys(item || {}).find(
                    (key) => key.replace(/[\s_]/g, '').toLowerCase() === 'userid'
                )
                const previous = index > 0 ? data[index - 1] : null
                const repeatsUserAndStatus =
                    !!previous &&
                    (!userIdKey || previous?.[userIdKey] === item?.[userIdKey]) &&
                    previous?.eligibilityStatus === item?.eligibilityStatus

                return {
                    ...item,
                    ...(userIdKey ? { [userIdKey]: repeatsUserAndStatus ? '' : item[userIdKey] } : {}),
                    eligibilityStatus: repeatsUserAndStatus ? '' : item.eligibilityStatus ? (
                        <Tag color={item.eligibilityStatus === eligible ? 'green' : 'red'}>
                            {item.eligibilityStatus}
                        </Tag>
                    ) : null,
                    conditionStatus: item.conditionStatus ? (
                        <Tag color={item.conditionStatus === met ? 'green' : 'red'}>
                            {item.conditionStatus}
                        </Tag>
                    ) : null,
                }
            })
            setDebtReschedulingTable({
                data: formattedData,
                columns: data?.length > 0 ? tableHeaderConverter(data) : [],
                loading: false
            })
        } catch (error: any) {
            message.error(`${errorMessage} with Debt Rescheduling Data`)
            setDebtReschedulingTable({
                data: [],
                columns: [],
                loading: false
            })
        }
    }
    return (
        <div className="unPaginatedTables">
                <TableWrapper title='Debt Rescheduling Eligibility:'>
                    <CallCenterTable
                        title="Debt Rescheduling Eligibility"
                        rows={debtReschedulingTable.data}
                        columns={debtReschedulingTable.columns}
                        loading={debtReschedulingTable.loading}
                        pagination={false}
                        scrolling={debtReschedulingTable.loading || !debtReschedulingTable.data?.length ? { y: 240 } : { x: "max-content" }}
                    />
                </TableWrapper>
            </div>
    )
}

export default CallCenterDebtReschedulingTable